export const REACT_APP_NAME =
  process.env.REACT_APP_NAME || 'portal-captadores-touchlatam';
export const MAIN_BACKEND_URL =
  process.env.REACT_APP_MAIN_BACKEND_URL || '';
export const APP_LANGUAGE = process.env.REACT_APP_LANGUAGE || 'en';
export const ENV = process.env.NODE_ENV || 'development';

export enum MenuType {
    STANDARD_MENU = "STANDARD_MENU",
    IFRAME_VIEWER = "IFRAME_VIEWER",
    PARENT_MENU = "PARENT_MENU"
}
